import { PermanentEntry } from '@addins/core/menus';
import { MenuEntry } from '@services/menu/entry.schema';
import { PlannedMissionsViewComponent } from '../../views/planned-missions-view/planned-missions-view.component';

export class PlannedMissionsMenuEntry extends PermanentEntry {
  constructor() {
    super(new MenuEntry('PlannedMissions', 'assets/icons/planned-missions/planned-missions.svg', PlannedMissionsViewComponent, 900));
  }
}
